function getDescriptionForTag(tagOptions, tagName) {
  const allOptions = tagOptions.map((tagGroup) => tagGroup.options).flat()
  const option = allOptions.find((tag) => tag.value === tagName)

  if (option && option.description) {
    return option.description
  } else {
    return null
  }
}

function getTagOptionsForArrayOfTagNames(tagOptions, arrayOfTags) {
    const allOptions = tagOptions.map((tagGroup) => tagGroup.options).flat()
    const arrayOfTagOptions = allOptions.filter((option) => {
      return arrayOfTags?.includes(option.value)
    })
    return arrayOfTagOptions
}

export { getDescriptionForTag, getTagOptionsForArrayOfTagNames }
